import api from '../../API';
import { useLoaderData, useParams, useRevalidator } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { JsonEditor } from 'json-edit-react';
import { useAuth } from '../../providers/AuthContext';
import { queryClient } from '../../providers/AuthContext';
import { extractData, fetchApiQuery } from '../../utils/apiResponse';
import { useMutation } from '@tanstack/react-query';

function SchemaView(){
    const { user, pending } = useAuth();
    const revalidator = useRevalidator();
    const {name} = useParams();
    const loaded = useLoaderData() || [];
    const hasRevalidated = useRef(false);

    // Revalidate loader data when user logs in and we have an empty result (likely auth error)
    useEffect(() => {
        // If loaded is empty array and user just logged in, revalidate
        if (!pending && user && user._id && Array.isArray(loaded) && loaded.length === 0 && !hasRevalidated.current) {
            hasRevalidated.current = true;
            revalidator.revalidate();
        }
    }, [user, pending, loaded, revalidator]);

    // Reset hasRevalidated when data loads successfully
    useEffect(() => {
        if (Array.isArray(loaded) && loaded.length > 0) {
            hasRevalidated.current = false;
        }
    }, [loaded]);

    // All hooks must be called before any early returns
    const [def, setDef] = useState();
    const [index, setIndex] = useState(0);

    const saveSchemaMutation = useMutation({
        mutationFn: ({name, definition}) => api.post('bdsa/schema', {query: {name}, body: {definition}}),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['bdsa-schema', name] });
            revalidator.revalidate();
        },
    });

    // Show loading while revalidating
    if (pending || revalidator.state === 'loading' || (Array.isArray(loaded) && loaded.length === 0 && user && user._id && !hasRevalidated.current)) {
        return <div>Loading...</div>;
    }
    // console.log('loader data', xxx)
    
    const data = loaded.sort((a, b)=> b.version - a.version);

    function saveChanges(){
        console.log('saving',def);
        saveSchemaMutation.mutate({name, definition: def}, {
            onSuccess: (d) => {
                console.log('after saving', d);
            },
        });
    }
    function updateDefinition(updated){
        data[index].definition = updated;
        setDef(updated);
    }
    if(index>=0){
        return (
            <>
            <button onClick={()=>console.log('testing',def || data[index].definition)}>Test</button>
            <h3>Schema: {name}</h3>
            <label>Version:</label>
            <select onChange={ev=>{setIndex(ev.target.value); setDef(); }}>
                {data.map( (d,index) => <option key={index} value={index}>{d.version}</option>)}
            </select>
            <div>
                Definition:
                <button disabled={!def || saveSchemaMutation.isPending} style={{marginLeft:'3em'}} onClick={saveChanges}>
                    {saveSchemaMutation.isPending ? 'Saving...' : 'Save (will create a new version)'}
                </button>
            </div>
            <JsonEditor data={data[index].definition} setData={updateDefinition}></JsonEditor>
            
            </>
        )
    } else {
        return <div>Loading...</div>
    }

    
}

async function Loader({params}){
    const {name} = params;
    
    console.log('In loader', name);
    if(!name){
        return [];
    }
    
    const response = await fetchApiQuery(queryClient, {
        queryKey: ['bdsa-schema', name],
        queryFn: () => api.get('bdsa/schema', {query: {name: name}}),
        staleTime: 5 * 60 * 1000,
    });

    const data = extractData(response);
    if (!data) {
        throw new Error("Failed to fetch data from the BDSA");
    }

    return data;
}

export default SchemaView;
export { SchemaView, Loader };